import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 12 1.376 9c-.684-.547-.384-1.647.484-1.771L7 7l2.195-5.503a.9.9 0 0 1 1.61 0L13 7l5.14.229c.868.124 1.168 1.224.484 1.771L15 12l.989 5.857a1 1 0 0 1-1.437 1.036L10 16l-4.552 2.892a1 1 0 0 1-1.437-1.036L5 12z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }